import { render } from "./VuexIssueDocumentFormItem.vue?vue&type=template&id=0b87c942&scoped=true"
import script from "./VuexIssueDocumentFormItem.vue?vue&type=script&lang=js"
export * from "./VuexIssueDocumentFormItem.vue?vue&type=script&lang=js"

import "./VuexIssueDocumentFormItem.vue?vue&type=style&index=0&id=0b87c942&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b87c942"]])

export default __exports__